import { useState } from "react";
import { Box, BoxProps, Grow } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { calculateCountryColors } from "../../utils/utils";
import { selectVisaCountries } from "../../store/visaProgramSlice";
import World from "@react-map/world";
import ResizeObserver from 'react-resize-observer';
import IMTitle from "../../components/typography/IMText";
import IMText from "../../components/typography/IMTitle";
import CountryScoreRect from "./components/CountryScoreRect";
import IMPage from "../../components/common/layout/IMPage";

type Props = {} & BoxProps;

const PageShareVisaResult = ({ }: Props) => {
	const [containerWidth, setContainerWidth] = useState(0);
	const countries = useSelector(selectVisaCountries);
	const cityColors = calculateCountryColors(countries);

	return (
		<IMPage sx={{ backgroundColor: '#F6F6F6' }}>
			{/* <IMQuestionsProgressBar questionIndex={totalSectionsCount === 4 ? curCardIndex+1 : curCardIndex+1-4*5} totalStages={totalSectionsCount}></IMQuestionsProgressBar> */}
			<Box
				sx={{
					width: "calc(100% - 32px)",
					margin: '16px',
					flexShrink: 0,
				}}
			>
				<ResizeObserver onResize={({ width }) => { setContainerWidth(width); }} />
				<Grow
					in={true}
					timeout={400}
				>
					<div>
						<World
							size={containerWidth}
							hoverColor="orange"
							type='select-single'
							cityColors={cityColors}
							strokeColor="#999999"
							mapColor="#00000000"
							disableClick={true}
							disableHover={true}
						/>
					</div>
				</Grow>

			</Box>
			<Box sx={{
				borderRadius: '16px',
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
				backgroundColor: '#FFFFFF',
				overflow: 'hidden',
				marginTop: '30px'
			}}>
				<Box
					sx={{
						background: '#FFFFFF',
						borderRadius: '12px',
						display: 'flex',
						flexDirection: 'column',
						height: '108px',
						justifyContent: 'center',
						boxShadow: '0px 0px 34px 0px #0000001A',
						padding: '0 40px',
						flexShrink: 0,
						position: 'absolute',
						marginTop: '-50px',
						zIndex: 1,
						left: '12px',
						right: '12px'
					}}
				>
					<IMTitle weight="700" size="22px" color="#212B36" textAlign="center">
						Поздравляем
					</IMTitle>
					<IMText
						weight="500"
						size="16px"
						color="#212B36"
						textAlign="center"
						props={{ marginTop: '6px' }}
					>
						Вот список наиболее подходящих стран для эмиграции
					</IMText>
				</Box>
				<Box sx={{
					height: '100%',
					display: 'flex',
					padding: '0px 12px 12px 12px',
					flexDirection: 'column',
					position: 'relative',
				}}>
					<Box sx={{
						height: '100%',
						overflow: 'auto',
						padding: '0 0 0 0',
						margin: '60px 0 0 0'
					}}>
						{countries.map((country, index) => (
							<Grow
								in={true}
								style={{ transitionDelay: `${index * 50}ms` }}
								timeout={400}
								key={country.id}
							>
								<div>
									<CountryScoreRect
										sx={{ marginTop: '12px' }}
										country={country}
										number={index + 1}
										highlighted={true}
									/>
								</div>
							</Grow>
						))}
					</Box>
				</Box>
			</Box>
		</IMPage>
	);
};

export default PageShareVisaResult;
